import { useEffect, useState } from "react";
import SectionLabel from "@/components/SectionLabel";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then(r => setItems(r.data)).catch(()=>{}); }, []);

  return (
    <div>
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <SectionLabel>Testimonials</SectionLabel>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900">Real stories from patients.</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">Kind words that keep us humble and motivated.</p>

          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((t, i) => (
              <div key={t.id} className="rounded-2xl border border-slate-200/70 p-6 bg-white aarogya-shadow"
                   data-testid={`testimonial-full-${i}`}>
                <div className="flex items-center gap-1 text-amber-500">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}
                </div>
                <p className="mt-3 text-slate-700 italic leading-relaxed">“{t.quote}”</p>
                <div className="mt-4 text-sm">
                  <div className="font-semibold text-slate-900">{t.patient_name}</div>
                  {t.location && <div className="text-slate-500 text-xs">{t.location}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
